import React from "react";
import ChatBotify from "react-chatbotify";

const MyChatBot = () => {
  const API_BASE_URL = process.env.REACT_APP_API_URL;

  const flow = {
    start: {
      message: "Welcome! How can I assist you today?",
      path: "handle-question",
    },

    "handle-question": {
      message: async (params) => {
        const userInput =
          typeof params.userInput === "string"
            ? params.userInput.toLowerCase().trim()
            : "";

        if (
          userInput.includes("upload resume") ||
          userInput.includes("send my resume") ||
          userInput.includes("submit resume")
        ) {
          return {
            message: "Sure! Please upload your resume below.",
            path: "handle-upload",
            fileEnabled: true,
          };
        }

        if (
          userInput.includes("elevator pitch") ||
          userInput.includes("pitch myself")
        ) {
          return {
            message: "Would you like to generate a custom elevator pitch?",
            options: [
              { label: "Yes, use my transcript", path: "generate-pitch" },
              { label: "Not now", path: "handle-question" },
            ],
          };
        }

        if (
          userInput.includes("live person") ||
          userInput.includes("human") ||
          userInput.includes("real person") ||
          userInput.includes("talk to someone") ||
          userInput.includes("live chat")
        ) {
          return {
            message: "Would you like to speak with a support team member?",
            options: [
              { label: "Yes, connect me", path: "live-transfer" },
              { label: "No, continue with AI", path: "handle-question" },
            ],
            path: "await-selection",
          };
        }

        try {
          const token = localStorage.getItem("token");
          const response = await fetch(`${API_BASE_URL}/chatbot/ask`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ message: userInput }),
          });

          if (!response.ok) throw new Error("Failed to get response");

          const reply = await response.text();
          return reply;
        } catch (error) {
          console.error("❌ Chatbot error:", error);
          return "Hmm... I couldn't reach the assistant. Please try again later.";
        }
      },
      path: "handle-question",
    },

    "handle-upload": {
      message: "Processing your resume...",
      chatDisabled: true,
      file: async (params) => {
        const file = params.files[0];
        const formData = new FormData();
        formData.append("file", file);

        try {
          const token = localStorage.getItem("token");
          const response = await fetch(`${API_BASE_URL}/resume/analyze`, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: formData,
          });

          const result = await response.text();
          return `✅ Resume received! Here's a quick analysis:\n\n${result}`;
        } catch (err) {
          console.error("❌ Resume upload failed:", err);
          return "Upload failed. Please try again.";
        }
      },
      path: "handle-question",
    },

    "generate-pitch": {
      message: async () => {
        try {
          const token = localStorage.getItem("token");
          const response = await fetch(`${API_BASE_URL}/elevator-pitch/ai`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              transcript: "Based on your profile and experience...",
            }),
          });

          const data = await response.json();
          return `🎯 Here's your AI-generated pitch:\n\n${data.pitch}`;
        } catch (err) {
          console.error("❌ Elevator pitch generation failed:", err);
          return "Failed to generate your elevator pitch. Please try again.";
        }
      },
      path: "handle-question",
    },

    "live-transfer": {
      message: "Launching support chat with a live team member...",
      action: () => {
        window.dispatchEvent(new Event("show-support-chat"));
      },
      path: "handle-question",
    },

    "await-selection": {
      message: "Please choose an option above to continue.",
      path: "handle-question",
    },
  };

  return (
    <ChatBotify
      flow={flow}
      settings={{
        position: "bottom-right",
        placeholder: "Type your message...",
        fileAttachment: {
          disabled: false,
          multiple: false,
          accept: ".pdf,.doc,.docx,.txt",
        },
      }}
    />
  );
};

export default MyChatBot;
